import { lazy } from 'react';

const ReportesRoutes = [
	{
		path: '/reportes',
		component: lazy(() => import('../../views/Reportes/tipos')),
		exact: true,
		meta: {
			navLink: '/reportes',
			resource: 'reportes',
			action: 'show'
		}
	},
	{
		path: '/reportes/:tipo_reporte',
		component: lazy(() => import('../../views/Reportes')),
		meta: {
			navLink: '/reportes/:tipo_reporte',
			resource: 'reportes',
			action: 'show'
		}
	}
];

export default ReportesRoutes;
